export default {
    behavior_clearFilters: 'Limpiar filtros',
    behavior_clearAll: 'Limpiar todo',
}
